import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();
const { NEXT_PUBLIC_DOMAIN } = publicRuntimeConfig;

const title = 'USREM - Liquidity for Real Estate - Home - USREM';
const url = `https://${NEXT_PUBLIC_DOMAIN}`;
const description =
  'USREM partners with real estate sponsors to enable liquidity for their investors. USREM’s marketplace enables investors to buy and sell fractions of residential and commercial real estate properties, with the sponsors’ blessing.';

export default {
  title: title,
  description: description,
  canonical: url,
  openGraph: {
    url: url,
    title: title,
    description: description,
    images: [
      {
        url: `/images/og-img.jpg`,
        width: 1200,
        height: 630,
        alt: 'usremsecurities.com'
      }
    ],
    site_name: 'usremsecurities.com',
    type: 'website',
    locale: 'en'
  },
  additionalLinkTags: [
    {
      rel: 'icon',
      href: `/images/favicons/favicon.ico`,
      type: 'image/x-icon'
    },
    {
      type: 'image/png',
      sizes: '16x16',
      rel: 'icon',
      href: `/images/favicons/favicon-16x16.png`
    },
    {
      type: 'image/png',
      sizes: '32x32',
      rel: 'icon',
      href: `/images/favicons/favicon-32x32.png`
    },
    {
      type: 'image/png',
      sizes: '96x96',
      rel: 'icon',
      href: `/images/favicons/favicon-96x96.png`
    },
    {
      type: 'image/png',
      sizes: '120x120',
      rel: 'icon',
      href: `/images/favicons/favicon-120x120.png`
    },
    {
      rel: 'apple-touch-icon',
      sizes: '57x57',
      href: `/images/favicons/apple-touch-icon-57x57.png`
    },
    {
      rel: 'apple-touch-icon',
      sizes: '60x60',
      href: `/images/favicons/apple-touch-icon-60x60.png`
    },
    {
      rel: 'apple-touch-icon',
      sizes: '72x72',
      href: `/images/favicons/apple-touch-icon-72x72.png`
    },
    {
      rel: 'apple-touch-icon',
      sizes: '76x76',
      href: `/images/favicons/apple-touch-icon-76x76.png`
    },
    {
      rel: 'apple-touch-icon',
      sizes: '114x144',
      href: `/images/favicons/apple-touch-icon-114x144.png`
    },
    {
      rel: 'apple-touch-icon',
      sizes: '120x120',
      href: `/images/favicons/apple-touch-icon-120x120.png`,
      type: 'image/png'
    },
    {
      rel: 'apple-touch-icon',
      sizes: '144x144',
      href: `/images/favicons/apple-touch-icon-144x144.png`,
      type: 'image/png'
    },
    {
      rel: 'apple-touch-icon',
      sizes: '152x152',
      href: `/images/favicons/apple-touch-icon-152x152.png`,
      type: 'image/png'
    },
    {
      rel: 'apple-touch-icon',
      sizes: '160x160',
      href: `/images/favicons/apple-touch-icon-160x160.png`,
      type: 'image/png'
    },
    {
      rel: 'apple-touch-icon',
      sizes: '167x167',
      href: `/images/favicons/apple-touch-icon-167x167.png`,
      type: 'image/png'
    },
    {
      rel: 'apple-touch-icon',
      sizes: '180x180',
      href: `/images/favicons/apple-touch-icon-180x180.png`,
      type: 'image/png'
    },
    {
      rel: 'apple-touch-icon',
      sizes: '260x260',
      href: `/images/favicons/apple-touch-icon-260x260.png`,
      type: 'image/png'
    },
    {
      rel: 'apple-touch-icon',
      sizes: '384x384',
      href: `/images/favicons/apple-touch-icon-384x384.png`
    },
    {
      rel: 'apple-touch-icon',
      sizes: '512x512',
      href: `/images/favicons/apple-touch-icon-512x512.png`
    },
    {
      rel: 'android-chrome',
      sizes: '192x192',
      href: `/images/favicons/android-chrome-192x192.png`
    },
    {
      rel: 'android-chrome',
      sizes: '256x256',
      href: `/images/favicons/android-chrome-256x256.png`
    },
    {
      rel: 'android-icon',
      sizes: '192x192',
      href: `/images/favicons/android-icon-192x192.png`
    },
    {
      rel: 'android-touch-icon',
      sizes: '128x128',
      href: `/images/favicons/android-touch-icon-128x128.png`
    },
    {
      rel: 'android-touch-icon',
      sizes: '192x192',
      href: `/images/favicons/android-touch-icon-192x192.png`
    }
  ]
};
